/**
 * Uses dropdown to add accordion functionality.
 * Function should be called on dropdown's immediate previous sibling.
 * Allows for stacking of blocks to create accordion.
 * Does NOT close other drawers on open.
 **/

const toggleAccordion = function (event) {
  if (event) event.preventDefault();
  const btn = event.currentTarget;
  const element = btn.nextElementSibling;

  btn.classList.toggle('button--active');
  element.classList.toggle('active');
};

export const dropdown = function () {
  window.Solver.toggleAccordion = toggleAccordion;
};
